module.exports = __webpack_public_path__ + "static/media/pharmacy.a9ec14e7.jpg";